import labels from './labels';
import messages from './messages';
import buttons from './buttons';

export default { ...labels, ...messages, ...buttons };
